import { createSlice } from '@reduxjs/toolkit';
import { PURGE } from 'redux-persist';
import requestStatus from 'common/constants/status';

const initialState = {
  data: {
    exerciseRankings: [],
    exercisePodium: { first: null, second: null, third: null },
    myRankings: [],
    myAchievements: [],
    myStreak: null,
    leaderboard: [],
    myGlobalRanking: null
  },
  status: {
    exerciseRankings: requestStatus.idle,
    exercisePodium: requestStatus.idle,
    myRankings: requestStatus.idle,
    myAchievements: requestStatus.idle,
    myStreak: requestStatus.idle,
    leaderboard: requestStatus.idle,
    myGlobalRanking: requestStatus.idle
  }
};

const gamificationSlice = createSlice({
  name: 'gamification',
  initialState,
  reducers: {
    // Exercise Rankings
    fetchExerciseRankings: (state) => {
      state.status.exerciseRankings = requestStatus.loading;
    },
    fetchExerciseRankingsSuccess: (state, action) => {
      state.data.exerciseRankings = action.payload;
      state.status.exerciseRankings = requestStatus.success;
    },
    fetchExerciseRankingsError: (state) => {
      state.status.exerciseRankings = requestStatus.error;
    },

    // Exercise Podium
    fetchExercisePodium: (state) => {
      state.status.exercisePodium = requestStatus.loading;
    },
    fetchExercisePodiumSuccess: (state, action) => {
      state.data.exercisePodium = action.payload;
      state.status.exercisePodium = requestStatus.success;
    },
    fetchExercisePodiumError: (state) => {
      state.status.exercisePodium = requestStatus.error;
    },

    // My Rankings
    fetchMyRankings: (state) => {
      state.status.myRankings = requestStatus.loading;
    },
    fetchMyRankingsSuccess: (state, action) => {
      state.data.myRankings = action.payload;
      state.status.myRankings = requestStatus.success;
    },
    fetchMyRankingsError: (state) => {
      state.status.myRankings = requestStatus.error;
    },

    // My Achievements
    fetchMyAchievements: (state) => {
      state.status.myAchievements = requestStatus.loading;
    },
    fetchMyAchievementsSuccess: (state, action) => {
      state.data.myAchievements = action.payload;
      state.status.myAchievements = requestStatus.success;
    },
    fetchMyAchievementsError: (state) => {
      state.status.myAchievements = requestStatus.error;
    },

    // My Streak
    fetchMyStreak: (state) => {
      state.status.myStreak = requestStatus.loading;
    },
    fetchMyStreakSuccess: (state, action) => {
      state.data.myStreak = action.payload;
      state.status.myStreak = requestStatus.success;
    },
    fetchMyStreakError: (state) => {
      state.status.myStreak = requestStatus.error;
    },

    // Leaderboard
    fetchLeaderboard: (state) => {
      state.status.leaderboard = requestStatus.loading;
    },
    fetchLeaderboardSuccess: (state, action) => {
      state.data.leaderboard = action.payload;
      state.status.leaderboard = requestStatus.success;
    },
    fetchLeaderboardError: (state) => {
      state.status.leaderboard = requestStatus.error;
    },

    // My Global Ranking
    fetchMyGlobalRanking: (state) => {
      state.status.myGlobalRanking = requestStatus.loading;
    },
    fetchMyGlobalRankingSuccess: (state, action) => {
      state.data.myGlobalRanking = action.payload;
      state.status.myGlobalRanking = requestStatus.success;
    },
    fetchMyGlobalRankingError: (state) => {
      state.status.myGlobalRanking = requestStatus.error;
    },

    // Reset state
    reset: () => initialState
  },
  // Era el ÚNICO slice sin esto: el ranking y los puntos del usuario anterior sobrevivían al
  // logout y los veía la siguiente cuenta hasta que algo los sobreescribiera.
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => initialState);
  }
});

export default gamificationSlice;
